import React from 'react';
import { ActivityIcon, BotIcon, CalendarCheckIcon, FileCheckIcon, NetworkIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { BONUS_VALUE, bonuses } from '../data/content';
const ICONS = {
  activity: ActivityIcon,
  check: FileCheckIcon,
  calendar: CalendarCheckIcon,
  network: NetworkIcon,
  bot: BotIcon
};

/* Colores de cada bono, igual que en la portada del pack */
const BONUS_COLORS = ['bg-brand-red', 'bg-brand-blue', 'bg-brand-green', 'bg-brand-orange', 'bg-brand-violet'];
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-white text-brand-night" data-id="element-27" data-mp="1eje040ytl6wb">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-28" data-mp="1elgokgkbqryx">
        <h2 id="bonos" className="font-display text-lg font-black uppercase leading-tight sm:text-2xl" data-id="element-29" data-mp="19lm2cqbhuqk7">
          <span className="bg-brand-yellow px-1.5" data-id="element-30" data-mp="1nhpp5yk1fwmn">5 Bonos incluidos</span>
        </h2>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-snug text-brand-night/75" data-id="element-31" data-mp="1jgdwtl9s4xar">
          Y además recibes 5 recursos prácticos — GRATIS con tu compra.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-32" data-mp="3tsff4u8tfk0n">
          {bonuses.map((bono, i) => {
          const Icon = ICONS[bono.icon];
          return <Reveal key={bono.title} as="li" delay={i * 0.03} className="flex h-full flex-col overflow-hidden rounded-lg border-2 border-brand-night/10 bg-white text-left" data-id="element-33" data-mp="7l8i7abvhqss" data-mpi={i}>
                <span className={`flex items-center gap-1.5 px-2.5 py-1 font-display text-[0.62rem] font-black uppercase tracking-[0.1em] text-white ${BONUS_COLORS[i]}`} data-id="element-34" data-mp="gjaoo5edlbng">
                  <Icon size={12} aria-hidden="true" data-id="element-35" data-mp="qdb4p2b741ay" />
                  Bono {i + 1} — Gratis
                </span>
                <div className="flex flex-1 flex-col p-2.5" data-id="element-36" data-mp="109e4i1ikrnuq">
                  <h3 className="font-display text-[0.8rem] font-extrabold uppercase leading-tight" data-id="element-37" data-mp="109mg7q2yon4c">
                    {bono.title}
                  </h3>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-brand-night/75" data-id="element-38" data-mp="5mnuzmbs2k0y">
                    {bono.desc}
                  </p>
                  <p className="mt-auto pt-1 font-num text-sm uppercase tracking-wide text-brand-night/60 line-through decoration-brand-red decoration-2" data-id="element-39" data-mp="kcd0tuutfc7k">
                    {bono.value}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>

        <div className="mt-3 inline-block rounded-lg border-2 border-dashed border-brand-orange bg-[#FFF6D6] px-3 py-2 font-display text-[0.78rem] font-black uppercase leading-tight sm:text-sm" data-id="element-40" data-mp="oc3zekql2wmn">
          <p data-id="element-41" data-mp="ybcq94q5jv4s">💰 Valor total de los 5 bonos: {BONUS_VALUE}</p>
          <p className="mt-0.5 text-brand-red" data-id="element-42" data-mp="350rb45u91m83">
            🔥 Hoy los 5 están incluidos gratis.
          </p>
        </div>
      </div>
    </section>;
}